import { cn } from '../../lib/cn';

type AuthStatus = 'live' | 'configurable' | 'planned' | 'future';

type Props = {
  label: string;
  status: AuthStatus;
  description?: string;
};

const statusStyles: Record<AuthStatus, string> = {
  live: 'border-success-200 bg-success-50 text-success-800 dark:border-success-800 dark:bg-success-950 dark:text-success-300',
  configurable: 'border-brand-200 bg-brand-50 text-brand-800 dark:border-brand-800 dark:bg-brand-950 dark:text-brand-300',
  planned: 'border-warning-200 bg-warning-50 text-warning-800 dark:border-warning-800 dark:bg-warning-950 dark:text-warning-300',
  future: 'border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400',
};

const statusLabel: Record<AuthStatus, string> = {
  live: 'Live',
  configurable: 'Admin Configurable',
  planned: 'Planned',
  future: 'Future',
};

export function AuthMethodCard({ label, status, description }: Props) {
  return (
    <div className={cn('rounded-lg border p-3', statusStyles[status])}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-medium">{label}</p>
        <span className="shrink-0 rounded-full bg-white/60 px-2 py-0.5 text-xs font-semibold dark:bg-black/20">
          {statusLabel[status]}
        </span>
      </div>
      {description && <p className="mt-1 text-xs opacity-80">{description}</p>}
    </div>
  );
}
